import ConstructionIcon from "@mui/icons-material/ConstructionRounded";
import { Container, Paper, Stack, Switch, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import type { WorkflowTemplateVersionDetails } from "../../../../api/types/workflowTypes";

interface Props {
  workflowTemplate: WorkflowTemplateVersionDetails;
}

const WorkflowTemplateSettings = ({ workflowTemplate }: Props) => {
  return (
    <ScrollableFlexContainer sx={{ height: "100%" }}>
      <Container maxWidth="lg" sx={{ height: "100%" }}>
        <Paper variant="outlined">
          <Stack spacing={2} sx={{ p: 2 }}>
            <Typography variant="subtitle1">AI Agent Tools</Typography>
            {workflowTemplate.aiAgentTools.map((tool) => (
              <Paper key={tool.displayName} variant="outlined" sx={{ p: 2 }}>
                <Stack direction="row" spacing={1} sx={{ alignItems: "center", mb: 1 }}>
                  <ConstructionIcon color="action" />
                  <Typography variant="subtitle2">{tool.displayName}</Typography>
                  <HorizontalFill />
                  <Switch checked disabled />
                </Stack>
                <Typography variant="caption" color="textSecondary">
                  {tool.description}
                </Typography>
              </Paper>
            ))}
          </Stack>
        </Paper>
      </Container>
    </ScrollableFlexContainer>
  );
};

export default WorkflowTemplateSettings;
